import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { mayaCustomerInitiativeListRoute } from 'basics/constants/routes.constants';
import { succesToast, warningToast } from 'basics/utils/toast';
import { CiFormSubmitCallbackType } from 'modules/maya/components/CustomerInitiativeForm/CustomerInitiativeForm.types';
import { useCreateCustomerInitiativeMutation } from 'modules/maya/graphql/mutations/createCustomerInitiative';
import useGetStrategicImperativeByIdQuery from 'modules/maya/graphql/queries/getStrategicImperativeById';

const useCustomerInitiativeCreate = () => {
  const navigate = useNavigate();

  const [createCustomerInitiative] = useCreateCustomerInitiativeMutation();

  const urlParams = useMemo(() => new URLSearchParams(window.location.search), []);
  const parentId = urlParams.get('parentId');

  const [loading, setLoading] = useState(true);

  const parentStrategicImperative = useGetStrategicImperativeByIdQuery(parentId).data;

  useEffect(() => {
    if (parentStrategicImperative || !parentId) {
      setLoading(false);
    }
  }, [parentId, parentStrategicImperative, setLoading]);

  const handleCancelCustomerInitiativeForm = () => {
    navigate(mayaCustomerInitiativeListRoute);
  };

  const handleSaveCustomerInitiativeForm: CiFormSubmitCallbackType = async (customerInitiative) => {
    const customerInitiativeData = await createCustomerInitiative({ ...customerInitiative, isTemplate: false });

    if (customerInitiativeData) {
      succesToast(`Customer initiative ${customerInitiative.title} created`);
      navigate(mayaCustomerInitiativeListRoute);
    } else {
      navigate(mayaCustomerInitiativeListRoute);
      warningToast(`Cannot create customer initiative ${customerInitiative.title}`);
    }
  };

  return {
    loading,
    parentStrategicImperative,
    handleSaveCustomerInitiativeForm,
    handleCancelCustomerInitiativeForm,
  };
};

export default useCustomerInitiativeCreate;
